<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Transfer
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex flex-wrap">
                <!-- filter date -->
                <!-- <div class="shadow d-flex">
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <p class="mt-5 fs-small">s/d</p>
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <v-btn :disabled="!search" class="mt-5" small color="primary">
                    <v-icon>mdi-calendar-filter</v-icon>
                  </v-btn>
                </div> -->
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >
            
              <template v-slot:[`item.spare_part_transfer_warehouse_from_id`]="{ item }">
                {{ item.spare_part_transfer_warehouse_from.warehouse_name }}
              </template>
              <template v-slot:[`item.spare_part_transfer_warehouse_to_id`]="{ item }">
                {{ item.spare_part_transfer_warehouse_to.warehouse_name }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailTransfer(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        role.update
                      "
                      @click="editTransfer(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.delete && item.vehicle_status == 0"
                      @click="deleteConfirmation(item.id)"
                    >
                      <v-list-item-title x-small>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalDetailPage">
      <template v-slot:body>
        <detail-transfer :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>Transfer Spare Part</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-transfer />
      </template>
    </modal>
    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>Edit Transfer Spare Part</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-transfer :data_id="$refs.modalEditPage.data" />
      </template>
    </modal>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import JsonExcel from "vue-json-excel";
import AddTransfer from "@/pages/Dashboard/Workshop/SparePartTransfer/AddSPTPage.vue";
import editTransfer from "@/pages/Dashboard/Workshop/SparePartTransfer/EditSPTPage.vue";
import detailTransfer from "@/pages/Dashboard/Workshop/SparePartTransfer/DetailSPTPage.vue";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    "add-transfer": AddTransfer,
    "detail-transfer": detailTransfer,
    "edit-transfer": editTransfer,
  },
  vuetify,
  data() {
    return {
      mounted: true,
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Transfer No", value: "spare_part_transfer_no" },
      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: false,
      role: "",
      search: "",
      options: {},
      headers: [
        {
          text: "Actions",
          align: "start center",
          value: "actions",
          sortable: false,
        },
        { text: "Transfer No", value: "spare_part_transfer_no" },
        { text: "From", value: "spare_part_transfer_warehouse_from_id" },
        { text: "To", value: "spare_part_transfer_warehouse_to_id" },
        { text: "Remark", value: "spare_part_transfer_remark" },
        { text: "Created At", value: "created_at", align: "center" },
      ],
      table: [],
      worksheetName: "Spare Part Transfer",
      fileName: "Spare Part Transfer.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      field_export: {
        "No": "no",
        "Transfer No" : "spare_part_transfer_no",
        "from Warehouse":"spare_part_transfer_warehouse_from_id",
        "to Warehouse": "spare_part_transfer_warehouse_to_id",
        "Remark": "spare_part_transfer_remark",
        "No Item":"no_item",
        "Spare Part Name": "spare_part_name",
        "Qty": "spare_part_qty",
        "Remark": "spare_part_remark",
        "Cretaed At": "created_at",
        "Updated At": "updated_at",
      },
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    this.mounted = false;
  },
  methods: {

    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      await this.$store.dispatch("workshop_spare_part_transfer/list", query);
      
      this.table = await this.$store.getters["workshop_spare_part_transfer/list"];
      var pageMeta = await this.$store.getters["workshop_spare_part_transfer/page"];

      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },
    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
    },


    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    editTransfer(id) {
      this.$refs.modalEditPage.openModal({ id: id });
      this.getList();
    },

    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    detailTransfer(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },

    modalCloseDetail() {
      this.$refs.modalDetailPage.closeModal();
      this.getList();
    },

    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteTransfer(id);
        }
      });
    },

    // fungsi delete data
    async deleteTransfer(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("workshop_spare_part_transfer/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle data delete successfully."
        );
        //kembali ke page list
        // this.$router.replace({ name: "List Vehicle" });
        this.getList();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        console.log("ewww");
        if (type == "all") {
          await this.$store.dispatch("workshop_spare_part_transfer/list");
          return this.dataExport(await this.$store.getters["workshop_spare_part_transfer/list"]);
        } else if (type == "filter") {
          var query = {};

          if (this.searchValue && this.searchCategory) {
            query.filter = { [this.searchCategory]: this.searchValue };
          }


          await this.$store.dispatch("workshop_spare_part_transfer/list", query);
          return this.dataExport(
            await this.$store.getters["workshop_spare_part_transfer/list"]
          );
        }
      }
    },
    dataExport(data) {
      var dataReturn = [];
      data.forEach((value_1, index_1) => {

        var spare_part_transfer_item_length = value_1.spare_part_transfer_item
          ? value_1.spare_part_transfer_item.length
          : 0;

        for (
          let i = 0;
          i <
          Math.max(
            spare_part_transfer_item_length
          );
          i++
        ) {
          var data = {
            no:
              dataReturn[index_1] && dataReturn[index_1].no == index_1 + 1
                ? null
                : index_1 + 1,
                
            spare_part_transfer_no: value_1.spare_part_transfer_no,
            spare_part_transfer_warehouse_from_id: value_1.spare_part_transfer_warehouse_from.warehouse_name,
            spare_part_transfer_warehouse_to_id: value_1.spare_part_transfer_warehouse_to.warehouse_name,
            spare_part_transfer_remark: value_1.spare_part_transfer_remark,
            no_item: value_1.spare_part_transfer_item[i] ? i + 1 : null,
            spare_part_name: value_1.spare_part_transfer_item[i].spare_part ? value_1.spare_part_transfer_item[i].spare_part.spare_part_master_name: null,
            spare_part_qty: value_1.spare_part_transfer_item[i].spare_part_transfer_item_qty ? value_1.spare_part_transfer_item[i].spare_part_transfer_item_qty: null,
            spare_part_remark: value_1.spare_part_transfer_item[i].spare_part_transfer_item_remark ? value_1.spare_part_transfer_item[i].spare_part_transfer_item_remark: null,
            created_at: value_1.created_at,
            updated_at: value_1.created_at,
          };
          dataReturn.push(data);
        }
      });
      return dataReturn;
      
    }
  },
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}


</style>
